import { useState, useEffect } from 'react';
import { fetchAdminStats } from '@/services/api';

interface Stats {
  activeAuctions: number;
  totalUsers: number;
  newUsers7d: number;
  newInquiries24h: number;
  avgResponseTimeMs: number;
}

export function AdminDashboardPage() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdminStats().then(setStats).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="container-content py-12"><p className="text-text-secondary">Laden...</p></div>;
  if (!stats) return <div className="container-content py-12"><p className="text-text-secondary">Fehler beim Laden.</p></div>;

  const avgResponseMin = stats.avgResponseTimeMs > 0
    ? Math.round(stats.avgResponseTimeMs / 60000)
    : '—';

  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Administration</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        <StatCard label="Aktive Auktionen" value={stats.activeAuctions} />
        <StatCard label="Offene Anfragen (24h)" value={stats.newInquiries24h} />
        <StatCard label="Gesamte Nutzer" value={stats.totalUsers} />
        <StatCard label="Neue Nutzer (7d)" value={stats.newUsers7d} />
        <StatCard label="Ø Antwortzeit Anfragen" value={`${avgResponseMin} Min.`} />
      </div>

      <nav className="space-y-2">
        <a href="/admin/auktionen" className="block p-3 border border-surface-border rounded-sm hover:bg-surface-alt transition-colors duration-150 no-underline">
          Auktionen verwalten
        </a>
        <a href="/admin/nutzer" className="block p-3 border border-surface-border rounded-sm hover:bg-surface-alt transition-colors duration-150 no-underline">
          Nutzer und Unternehmen
        </a>
        <a href="/admin/einladungen" className="block p-3 border border-surface-border rounded-sm hover:bg-surface-alt transition-colors duration-150 no-underline">
          Einladungscodes
        </a>
        <a href="/admin/zuschlaege" className="block p-3 border border-surface-border rounded-sm hover:bg-surface-alt transition-colors duration-150 no-underline">
          Zuschläge und Compliance
        </a>
        <a href="/admin/anfragen" className="block p-3 border border-surface-border rounded-sm hover:bg-surface-alt transition-colors duration-150 no-underline">
          Anfragen ({stats.newInquiries24h} neu)
        </a>
        <a href="/admin/protokolle" className="block p-3 border border-surface-border rounded-sm hover:bg-surface-alt transition-colors duration-150 no-underline">
          Audit-Protokolle
        </a>
      </nav>
    </div>
  );
}

function StatCard({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="p-4 border border-surface-border rounded-sm">
      <div className="text-sm text-text-muted mb-1">{label}</div>
      <div className="text-2xl font-serif">{value}</div>
    </div>
  );
}
